<ion-item lines="none" mode="md" color="white" class="separator">
  <ion-label
    color="grayDemon"
    class="ion-float-left ion-align-self-start have-not-added-products"
  >
    <ng-container
      *ngIf="exchange < 1; then Empty; else Products"
    ></ng-container>

    <ng-template #Empty>
      <p>
        {{
          'Labels.' +
            (isBonus ? 'have-not-added-bonus' : 'have-not-added-products')
            | translate
        }}
      </p>
    </ng-template>

    <ng-template #Products>
      <ng-container
        *ngIf="
          (productosPromocion | sumTotal : 'productos') < 1;
          then Empty;
          else ListProducts
        "
      >
      </ng-container>
    </ng-template>

    <ng-template #ListProducts>
      <ng-container *ngFor="let product of productosPromocion">
        <ng-container *ngIf="product.productos > 0">
          <p>{{ exchange * product.productos }} {{ product.title }}</p>
        </ng-container>
      </ng-container>
    </ng-template>
  </ion-label>

  <ion-label class="ion-float-right ion-text-end">
    <ng-container *ngIf="exchange < 1">
      <p class="a_precio_total_original">{{ exchange | currency }}</p>
      <p class="b_precio_descontado">- {{ exchange | currency }}</p>
      <p class="c_precio_final">{{ exchange | currency }}</p>
    </ng-container>

    <ng-container *ngIf="exchange > 0">
      <p class="total_precio">
        {{
          (productosPromocion | summaryPrice : exchange).total_precio | currency
        }}
      </p>
      <p class="total_descuento">
        {{
          (productosPromocion | summaryPrice : exchange).total_descuento
            | currency
        }}
      </p>
      <p class="total_precio_descuento">
        {{
          (productosPromocion | summaryPrice : exchange).total_precio_descuento
            | currency
        }}
      </p>
    </ng-container>
  </ion-label>
</ion-item>
